import React from "react";
import { Preview, ElementState } from "@creatomate/preview";
import { NumberField } from "@culturehq/components";
import { Trans } from "app/utils";

interface RotateProps {
  activeElement: ElementState;
  disabled?: boolean;
  preview: Preview;
}
const MAX_ROTATION = 360;
const DEFAULT_ROTATION = 0;

const Rotate: React.FC<RotateProps> = ({
  activeElement,
  disabled,
  preview
}) => {
  const handleTextRotateChange = async (value: string) => {
    let rotation = +value;
    if (rotation > MAX_ROTATION) rotation = MAX_ROTATION;
    if (rotation < -MAX_ROTATION) rotation = -MAX_ROTATION;
    // Update the "z_rotation" property, adding the unit "°"
    await preview.applyModifications({
      [`${activeElement.source.id}.z_rotation`]: `${rotation}°`
    });
  };
  // Extract the current z_rotation value, removing the "°"
  const currentRotation = activeElement?.source?.z_rotation
    ? activeElement.source.z_rotation.replace("°", "")
    : String(DEFAULT_ROTATION);
  return (
    <NumberField
      className="chq-ffd-border"
      disabled={disabled}
      name="rotate"
      min={-MAX_ROTATION}
      max={MAX_ROTATION}
      value={currentRotation}
      onChange={handleTextRotateChange}
    >
      <Trans>Rotate (°)</Trans>
    </NumberField>
  );
};

export default Rotate;
